import { createFileRoute } from '@tanstack/react-router';
import { requireOrgAdminBeforeLoad } from '../../../lib/org-admin-guard';

export const Route = createFileRoute('/_authenticated/company/org-chart')({
  beforeLoad: requireOrgAdminBeforeLoad
}).lazy(() => import('./org-chart.lazy').then((d) => d.Route));
